"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatDateRange;

var _constants = require("./constants");

var _formatDate = _interopRequireDefault(require("./formatDate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function formatDateRange(locale, startDate, endDate) {
  return [startDate, endDate].filter(Boolean).map(function (date) {
    return (0, _formatDate["default"])(locale, _constants.DATE_RANGE_FORMAT, date);
  }).join(' - ');
}